import React, { useEffect } from 'react'
import {
  Box,
  Button,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ErrorOutline } from '@material-ui/icons'

import ButtonDialogClose from '../common/ButtonDialogClose'
import { publishViewed } from '../../../util/events/teamsGiftsEventPublishers'
import { VIEWS } from '../../../util/events/teamsEvents'

const useStyles = makeStyles(theme => ({
  icon: {
    fontSize: '126px',
    color: theme.palette.error.light,
  },
}))

const ExitConfirmation = ({ onBack, onConfirm }) => {
  const classes = useStyles()

  useEffect(() => {
    publishViewed(VIEWS.CLOSE_GIFT_DIALOG)
  }, [])

  return (
    <>
      <DialogTitle>
        <ButtonDialogClose onClick={onConfirm} />
      </DialogTitle>
      <DialogContent>
        <Box display="flex" justifyContent="center">
          <Box textAlign="center" maxWidth="352px">
            <ErrorOutline className={classes.icon} />
            <Box marginY={3}>
              <Typography variant="h5">Are you sure you want to exit?</Typography>
            </Box>
            <Typography>
              If you leave now, you will lose your progress and have to start over if you return.
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onBack}>Back</Button>
        <Button color="primary" variant="contained" onClick={onConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </>
  )
}

export default ExitConfirmation
